module.exports = __webpack_public_path__ + "static/images/logo.7c33d5f6.jpg";